import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-173b59f9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "phone-qrcode" }
const _hoisted_2 = { class: "qy-cam-4" }
const _hoisted_3 = { class: "up" }
const _hoisted_4 = { class: "qy-cam-5" }
const _hoisted_5 = { class: "qr-code" }
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " UDS青翼工业软件 ", -1 /* HOISTED */))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " 公众号 ", -1 /* HOISTED */))
const _hoisted_9 = { class: "qr-code" }
const _hoisted_10 = ["src"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " 青翼CAX软件 ", -1 /* HOISTED */))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " 公众号 ", -1 /* HOISTED */))

import { ref, onMounted, watch } from "vue";
import { UseIcon } from "@/components";
import UDSQrCode from "../../../public/images/UDS青翼工业软件公众号@2x.png";
import CAXQrCode from "../../../public/images/青翼CAX软件公众号@2x.png";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    index: {
        type: Number
    }
},
  setup(__props) {

const props = __props;



let bodyWidth = 0;

onMounted(() => {
    bodyWidth = document.body.clientWidth;
});

const qyCodeShow = ref(false);
const rightShow = ref(true);

watch(
    () => props.index,
    () => {
        if (bodyWidth > 800) return;
        if (props.index === undefined) return;
        if (props.index !== 0) {
            rightShow.value = false;
        } else {
            rightShow.value = true;
        }
    }
);

return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_tooltip, {
        class: "tel-pop",
        effect: "telpop",
        content: "总机：021-33536920/21/22/23/24/25",
        placement: "left",
        "show-arrow": false,
        offset: 4
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(UseIcon), {
              iconClass: "icon-shouji",
              fontSize: 32,
              class: "svg-icon",
              color: "#feffff"
            })
          ])
        ]),
        _: 1 /* STABLE */
      }),
      _createElementVNode("div", {
        class: "down",
        onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (qyCodeShow.value = true)),
        onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (qyCodeShow.value = false))
      }, [
        _createVNode(_unref(UseIcon), {
          iconClass: "icon-erweima",
          fontSize: 32,
          class: "svg-icon",
          color: "#feffff"
        })
      ], 32 /* HYDRATE_EVENTS */)
    ]),
    _createVNode(_Transition, {
      name: "el-fade-in-linear",
      persisted: ""
    }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("img", {
              src: _unref(UDSQrCode),
              alt: ""
            }, null, 8 /* PROPS */, _hoisted_6),
            _hoisted_7,
            _hoisted_8
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("img", {
              src: _unref(CAXQrCode),
              alt: ""
            }, null, 8 /* PROPS */, _hoisted_10),
            _hoisted_11,
            _hoisted_12
          ])
        ], 512 /* NEED_PATCH */), [
          [_vShow, qyCodeShow.value]
        ])
      ]),
      _: 1 /* STABLE */
    })
  ], 512 /* NEED_PATCH */)), [
    [_vShow, rightShow.value]
  ])
}
}

})